/* APC: pin the products a customer searched for by name to the top of search.
 * Shopify ranks sold-out products last, so a customer who searches a plant by
 * name ("hydrangea", "grevillea lanigera mt tamboritha") can find unrelated
 * in-stock plants first and the plant itself on the last page, never seeing the
 * Back-In-Stock sign-up. Every product whose title (or one of its common-name
 * tags) contains every word they typed, allowing small typos, is pinned first -
 * in-stock matches, then sold-out matches, then everything else - on the /search
 * page and in the predictive dropdown. On the /search page, sold-out matches are
 * only pulled onto page 1 once the in-stock matches run out there, so a broad
 * search ("grevillea") still shows its in-stock plants first.
 * Revert: remove the apc-search-pin.js <script> tag from layout/theme.liquid. */
(function () {
  var ALIAS = { mount: 'mt', saint: 'st', cultivar: 'cv' };
  var cache = {};

  function tokens(s) {
    return String(s || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean)
      .map(function (t) { return ALIAS[t] || t; });
  }

  // Levenshtein distance, capped: returns max+1 as soon as it can't be <= max
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var best = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  // 2 = exact, 1 = typo (1 letter in words of 5+, 2 in words of 8+), 0 = no match
  function wordMatch(w, x, prefixOk) {
    if (x === w) return 2;
    if (prefixOk && w.length >= 3 && x.indexOf(w) === 0) return 2; // still typing
    var max = w.length >= 8 ? 2 : w.length >= 5 ? 1 : 0;
    return max > 0 && dist(w, x, max) <= max ? 1 : 0;
  }

  // Common names live in tags (e.g. "Woolly Grevillea 'Mt Tamboritha'"); skip the internal ones.
  var INTERNAL_TAG = /^(sc|rg|sz|apc)[:\-]|^all plants$/i;

  // every query word must match a word of the title or of one common-name tag.
  // The last word may be a prefix only while typing (dropdown) - a submitted
  // "rose" should not pin Rosemary. Returns 2 if every word matched exactly,
  // 1 if a typo was needed, 0 for no match.
  function matches(p, q, typing) {
    var tags = typeof p.tags === 'string' ? p.tags.split(',') : (p.tags || []);
    var names = [p.title].concat(tags.map(function (t) { return t.trim(); }).filter(function (t) { return t && !INTERNAL_TAG.test(t); }));
    return names.reduce(function (best, name) {
      var t = tokens(name);
      var level = q.reduce(function (lv, w, i) {
        var m = t.reduce(function (b, x) { return Math.max(b, wordMatch(w, x, typing && i === q.length - 1)); }, 0);
        return Math.min(lv, m);
      }, 2);
      return Math.max(best, level);
    }, 0);
  }

  // all matching products among the top 10 (sold out included), in-stock first.
  // Typo matches only count when nothing matches exactly ("gardenia" must not pin Goodenia).
  // Resolves to the pins, with .level = the match level they were taken at.
  function findPins(query, typing) {
    var q = tokens(query);
    if (!q.length || q.join('').length < 4) { var none = []; none.level = 0; return Promise.resolve(none); }
    var key = (typing ? 't:' : 's:') + q.join(' ');
    if (cache[key]) return cache[key];
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    cache[key] = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
      var levels = ps.map(function (p) { return matches(p, q, typing); });
      var level = Math.max.apply(null, levels.concat(0));
      var hits = level ? ps.filter(function (p, i) { return levels[i] === level; }) : [];
      hits = hits.filter(function (p) { return p.available; }).concat(hits.filter(function (p) { return !p.available; }));
      hits.level = level;
      return hits;
    }).catch(function () { var none = []; none.level = 0; return none; });
    return cache[key];
  }

  function handleOf(url) { var m = /\/products\/([^/?#]+)/.exec(url || ''); return m && m[1]; }
  function pinHandle(p) { return p.handle || handleOf(p.url); }

  // ---- full /search results page ----
  // AOS never animates a card it didn't see in place (its image stays at opacity 0), so mark it as already animated
  function showNow(card) {
    if (card.hasAttribute('data-aos')) card.classList.add('aos-init', 'aos-animate');
    card.querySelectorAll('[data-aos]').forEach(function (n) { n.classList.add('aos-init', 'aos-animate'); });
  }

  function fetchCard(handle) {
    return fetch('/products/' + handle + '?view=apc-card').then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var box = document.createElement('div');
      box.innerHTML = html.trim();
      var card = box.querySelector('.grid-product');
      if (!card) return null;
      card.removeAttribute('data-aos');
      card.setAttribute('data-apc-pinned', '');
      return card;
    }).catch(function () { return null; });
  }

  function pinResultsPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search);
    var query = p.get('q');
    if (!query || (p.get('page') && p.get('page') !== '1') || p.get('sort_by')) return;
    var filtered = false;
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0) filtered = true; });
    if (filtered) return;
    var grid = document.querySelector('#CollectionAjaxContent .grid__item--content .grid--uniform');
    if (!grid) return;
    var q = tokens(query);
    findPins(query, false).then(function (pins) {
      var pinned = {};
      pins.forEach(function (pin) { pinned[pinHandle(pin)] = true; });
      var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-product'));
      var byHandle = {};
      cards.forEach(function (c) { byHandle[c.getAttribute('data-product-handle')] = c; });
      function soldOut(c) { return !!c.querySelector('.grid-product__tag--sold-out'); }
      function isMatch(c) {
        if (pinned[c.getAttribute('data-product-handle')]) return true;
        var t = c.querySelector('.grid-product__title');
        return !!t && matches({ title: t.textContent }, q, false) >= (pins.level || 1);
      }
      var matched = cards.filter(isMatch);
      if (!pins.length && !matched.length) return;
      // in-stock matches carry on past page 1: leave the order alone and pull nothing in
      if (matched.length === cards.length) return;
      var missing = pins.filter(function (pin) { return !byHandle[pinHandle(pin)]; });
      Promise.all(missing.map(function (pin) { return fetchCard(pinHandle(pin)); })).then(function (fetched) {
        var extra = {};
        missing.forEach(function (pin, i) { if (fetched[i]) extra[pinHandle(pin)] = fetched[i]; });
        // page order first, then any pins not on the page, in-stock before sold-out
        var all = matched.slice();
        pins.forEach(function (pin) { var c = extra[pinHandle(pin)]; if (c) all.push(c); });
        var order = all.filter(function (c) { return !soldOut(c); }).concat(all.filter(soldOut));
        var anchor = grid.firstElementChild;
        // moved cards too: one pulled up from below the fold would never fade in
        order.forEach(function (c) { showNow(c); grid.insertBefore(c, anchor); if (c === anchor) anchor = c.nextElementSibling; });
      });
    });
  }

  // ---- predictive dropdown ----
  function money(price) {
    var cents = Math.round(parseFloat(price) * 100);
    if (window.theme && theme.Currency && theme.moneyFormat) return theme.Currency.formatMoney(cents, theme.moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }

  function cloneItem(template, pin) {
    var li = template.cloneNode(true);
    var link = li.querySelector('a');
    link.setAttribute('href', pin.url);
    var imgWrap = li.querySelector('.results-products__image');
    if (imgWrap) {
      imgWrap.innerHTML = '';
      var src = pin.featured_image && pin.featured_image.url || pin.image;
      if (src) {
        var img = document.createElement('img');
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        img.alt = pin.title; img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
    }
    var info = li.querySelector('.results-products__info');
    if (info) {
      var name = info.querySelector('span');
      if (name) name.textContent = pin.title + (pin.available ? '' : ' (sold out)');
      info.querySelectorAll('.grid-product__price--original, .grid-product__price--savings, .visually-hidden').forEach(function (n) { n.remove(); });
      var price = info.querySelector('.grid-product__price');
      if (price) price.textContent = money(pin.price);
    }
    return li;
  }

  function pinDropdown(box, input) {
    var list = box.querySelector('.results--products ul');
    if (!list || list.hasAttribute('data-apc-done')) return;
    list.setAttribute('data-apc-done', '');
    var query = input.value;
    findPins(query, true).then(function (pins) {
      if (!pins.length || input.value !== query || !list.isConnected) return;
      var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
      if (!items.length) return;
      var size = items.length;
      var byHandle = {};
      items.forEach(function (li) { var a = li.querySelector('a'); if (a) byHandle[handleOf(a.getAttribute('href'))] = li; });
      var anchor = list.firstElementChild;
      var used = [];
      pins.slice(0, size).forEach(function (pin) {
        var li = byHandle[pinHandle(pin)] || cloneItem(items[0], pin);
        list.insertBefore(li, anchor);
        if (li === anchor) anchor = li.nextElementSibling;
        used.push(li);
      });
      // keep the dropdown the same length, dropping non-matches from the bottom
      var all = list.querySelectorAll(':scope > li');
      for (var i = all.length - 1; i >= 0 && list.children.length > size; i--) {
        if (used.indexOf(all[i]) < 0) all[i].remove();
      }
    });
  }

  function watchDropdowns() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      var box = ps.querySelector('#predictive-search');
      var input = ps.querySelector('input[type="search"]');
      if (!box || !input || box.hasAttribute('data-apc-watch')) return;
      box.setAttribute('data-apc-watch', '');
      new MutationObserver(function () { pinDropdown(box, input); }).observe(box, { childList: true, subtree: true });
    });
  }

  function init() { pinResultsPage(); watchDropdowns(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
